module.exports = __webpack_public_path__ + "static/media/codeDesktop.4ce47bd5.mp3";